import React, { useState } from 'react';
import { StyleSheet, Text, View, Image, Button, TouchableOpacity, TouchableWithoutFeedback, Switch} from 'react-native';
import SoundDivider from '../SoundDivider';

const BattlegroundFilters = (props) => {

  const visibility = props.visibility
  const filterCards = props.filterCards
  const [includeBGTiers, setIncludeBGTiers] = props.bgFiltersHook['bgTiers']
  const [includeBGTokens, setIncludeBGTokens] = props.bgFiltersHook['bgTokens']
  const [includeBGTribes, setIncludeBGTribes] = props.bgFiltersHook['bgTribes']
  const [includeBGHeroSpecific, setIncludeBGHeroSpecific] = props.bgFiltersHook['bgHeroSpecific']
  const [includeBGRetired, setIncludeBGRetired] =  props.bgFiltersHook['bgRetired']

  const bgDict = {'bgTierFilter': includeBGTiers, 'bgTribeFilter': includeBGTribes, 'bgTokensFilter': includeBGTokens, 'bgHeroSpecificFilter': includeBGHeroSpecific, 'bgRetiredFilter': includeBGRetired}

  const TierFilter = (props) => {
    var tier = props.tier
    return (
      <View style={{paddingHorizontal: 4}}>
        <TouchableOpacity onPress={() => {
          var newBGTierFilter = includeBGTiers
          newBGTierFilter[tier] = !newBGTierFilter[tier]
          bgDict['bgTierFilter'] = newBGTierFilter
          filterCards(null, true, false, null, null, null, bgDict)
          setIncludeBGTiers(newBGTierFilter)
        }}>
          <Image style={{width: 42, height: 44}} source={require('../assets/img/techlevel'+tier+'.png')}/>
          <Image style={{width: 34, height: 44, marginTop: -44, marginLeft: 4, visibility: ((includeBGTiers[tier] || visibility == 'hidden') ? 'hidden' : 'visible')}} source={require('../assets/img/exclude.png')}/>
        </TouchableOpacity>
      </View>
    )
  }

  const TribeFilter = (props) => {
    var tribe = props.tribe
    return (
      <TouchableOpacity onPress={() => {
        var newBGTribeFilter = includeBGTribes
        newBGTribeFilter[tribe] = !newBGTribeFilter[tribe]
        bgDict['bgTribeFilter'] = newBGTribeFilter
        filterCards(null, true, false, null, null, null, bgDict)
        setIncludeBGTribes(newBGTribeFilter)
      }}>
        <Image style={{width: 34, height: 34}} source={require('../assets/img/bg_'+tribe.toLowerCase()+'s.png')}/>
        <Image style={{width: 26.15, height: 34, marginTop: -32, marginLeft: 4, visibility: ((includeBGTribes[tribe] || visibility == 'hidden') ? 'hidden' : 'visible')}} source={require('../assets/img/exclude.png')}/>
      </TouchableOpacity>
    )
  }

  const styles = StyleSheet.create({
    filterMenu:
      {position: 'absolute', right:48, top:56, zIndex: 1, backgroundColor: 'white', visibility:visibility,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5
    }
  })

  return (
    <View style={styles.filterMenu} >
      <View style={{padding: 16}}>
        <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
          <Text style={{paddingRight: 16}}>Tokens</Text>
          <Switch onValueChange={(newBGTokensFilter) => {
            bgDict['bgTokensFilter'] = newBGTokensFilter
            filterCards(null, true, false, null, null, null, bgDict)
            setIncludeBGTokens(newBGTokensFilter)
          }} value={includeBGTokens} />
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 16}}>
          <Text style={{paddingRight: 16}}>Hero-Specific</Text>
          <Switch onValueChange={(newBGHeroSpecificFilter) => {
            bgDict['bgHeroSpecific'] = newBGHeroSpecificFilter
            filterCards(null, true, false, null, null, null, bgDict)
            setIncludeBGHeroSpecific(newBGHeroSpecificFilter)
          }} value={includeBGHeroSpecific} />
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 16, paddingBottom: 16}}>
          <Text style={{paddingRight: 16}}>Retired</Text>
          <Switch onValueChange={(newRetiredFilter) => {
            bgDict['bgRetired'] = newRetiredFilter
            filterCards(null, true, false, null, null, null, bgDict)
            setIncludeBGRetired(newRetiredFilter)
          }} value={includeBGRetired} />
        </View>
        <SoundDivider />
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8}}>
          {[1,2,3].map(tier =>(<TierFilter tier={tier}/>))}
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8, paddingBottom: 16}}>
          {[4,5,6].map(tier =>(<TierFilter tier={tier}/>))}
        </View>
        <SoundDivider />
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8}}>
          {['Beast', 'Demon', 'Dragon'].map(tribe => (<TribeFilter tribe={tribe}/>))}
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8}}>
          {['Mech', 'Murloc', 'Pirate'].map(tribe => (<TribeFilter tribe={tribe}/>))}
        </View>
        <View style={{flexDirection: 'row', justifyContent: 'space-between', paddingTop: 8}}>
          {['Elemental', 'Neutral'].map(tribe => (<TribeFilter tribe={tribe}/>))}
        <View style={{padding: 16}} />
        </View>
      </View>
    </View>
  )
}

export default BattlegroundFilters
